<plyca-ui-tabs
  [config]="{
    tab: tabsSig,
    tabSelected: currentIndexSig(),
    cache: cacheTabSig(),
    badgeInTab: [1],
    badgeContentInEveryTab: badgeContentData(),
    class: 'badge badge-danger'
  }"
  (activeIndexChange)="onChangeIndex($event)"
>
  <ng-template let-tab let-i="index">
    @if (currentIndexSig() === 0) {
      <h4>Content One</h4>
    } @else if (currentIndexSig() === 1) {
      <h4>Content Two</h4>
    } @else if (currentIndexSig() === 2) {
      <h4>Content Three</h4>
    }
  </ng-template>
</plyca-ui-tabs>
